import { useState } from 'react'
import { SelectPicker, Loader } from 'rsuite'
import { PageHeading } from 'shared'
import DashCards from 'shared/molecules/dashCards/DashCards'
import { FaFileAlt, FaBullhorn, FaUserTie } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import Charts from 'shared/molecules/charts/Charts'
import { useGetWalletCountQuery } from 'pages/wallet/walletApiSlice'
import { payment } from 'pages/wallet/types'
import useAuth from '../../hooks/Auth'
import {
  useGetAllComapnyQuery,
  useGetDashboardCountQuery
} from './dashboardApiSlice'
import './dashboard.scss'

const Dashboard: React.FC = () => {
  const navigate = useNavigate()
  const [subId, setSubId] = useState<number>(0)
  const handleCardClick = (route: string) => {
    navigate(route)
  }
  const { role } = useAuth()
  const { data: WalletData } = useGetWalletCountQuery() as { data?: payment }

  const walletChartData = WalletData
    ? [
        ['Category', 'Amount'],
        ['Total Balance', WalletData.totalBalance],
        ['Spend Balance', WalletData.spendBalance]
      ]
    : []

  const { data: userDashboardData, isLoading: isDashboardLoading } =
    useGetDashboardCountQuery(subId ? { subId } : undefined)
  const { data: companyData, isLoading: isCompanyLoading } =
    useGetAllComapnyQuery()
  const formatChartData = (
    dashboardData: typeof userDashboardData | undefined
  ) => {
    if (!dashboardData) return {}

    const sumValues = (obj: Record<string, number> | undefined) =>
      obj ? Object.values(obj).reduce((acc, val) => acc + val, 0) : 0

    return {
      userChannelDistribution: dashboardData.data?.channelOnboardingCounts,
      userCampaignDistribution: dashboardData.data?.campaignChannelCounts,
      userTemplateDistribution: dashboardData.data?.templateChannelCounts,
      userTotalTemplate: sumValues(dashboardData.data?.templateChannelCounts),
      userTotalCampaign: sumValues(dashboardData.data?.campaignChannelCounts),
      adminTotalUser: dashboardData.data?.TotalUserCounts || 0,
      adminCampiagnDistribution: dashboardData.data?.campaignChannelCounts,
      adminChannelDistribution: dashboardData.data?.channelOnboardingCounts,
      adminTemplateDistribution: dashboardData.data?.templateChannelCounts,
      adminTotalTemplates: sumValues(dashboardData.data?.templateChannelCounts),
      adminTotalCampaigns: sumValues(dashboardData.data?.campaignChannelCounts)
    }
  }
  const userChartData = formatChartData(userDashboardData)

  const generateOptions = (
    data: { content: { name: string, subsId: number }[] } | undefined,
    isLoading: boolean
  ) =>
    isLoading
      ? []
      : (data?.content?.map((item: { name: string, subsId: number }) => ({
          label: item.name,
          value: item.subsId
        })) ?? [])
  const companyOptions = generateOptions(companyData, isCompanyLoading)

  const USER_DASHBOARD_DATA = [
    {
      title: 'Total Templates',
      description: isDashboardLoading ? (
        <Loader />
      ) : (
        userChartData.userTotalTemplate?.toString()
      ),
      icon: <FaFileAlt className="dashboard-icon" />,
      route: '/templates'
    },
    {
      title: 'Total Campaigns',
      description: isDashboardLoading ? (
        <Loader />
      ) : (
        userChartData.userTotalCampaign?.toString()
      ),
      icon: <FaBullhorn className="dashboard-icon iconfailed" />,
      route: '/campaigns'
    }
  ]
  const ADMIN_DASHBOARD_DATA = [
    {
      title: 'Total Users',
      description: isDashboardLoading ? (
        <Loader />
      ) : (
        userChartData.adminTotalUser?.toString()
      ),
      icon: <FaUserTie className="dashboard-icon " />,
      route: '/users'
    },
    {
      title: 'Total Templates',
      description: isDashboardLoading ? (
        <Loader />
      ) : (
        userChartData.adminTotalTemplates?.toString()
      ),
      icon: <FaFileAlt className="dashboard-icon" />,
      route: '/templates'
    },

    {
      title: 'Total Campaigns',
      description: isDashboardLoading ? (
        <Loader />
      ) : (
        userChartData.adminTotalCampaigns?.toString()
      ),
      icon: <FaBullhorn className="dashboard-icon iconfailed" />,
      route: '/campaigns'
    }
  ]

  const showCompanyDashboard = (value: number) => {
    setSubId(value)
  }
  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <PageHeading title="Welcome Back" />
        {role?.includes('ROLE_ADMIN') && (
          <SelectPicker
            data={companyOptions}
            placeholder="Select Company"
            className="dashboard-select"
            onChange={(value) => {
              showCompanyDashboard(value as number)
            }}
          />
        )}
      </div>

      {role?.includes('ROLE_ADMIN') ? (
        <>
          <DashCards
            data={ADMIN_DASHBOARD_DATA}
            onCardClick={handleCardClick}
          />
          <div className="dashboard-data">
            <div className="sub-dash">
              <div className="charts-container">
                <div className="pie-chart">
                  <h6>Wallet Distribution</h6>
                  <Charts type="Admin-wallet-pie" data={walletChartData} />
                </div>
                <div className="pie-chart">
                  <h6>Channel Distribution</h6>
                  {isDashboardLoading ? (
                    <Loader />
                  ) : (
                    <Charts
                      type="Admin-channel-pie"
                      data={userChartData.userChannelDistribution}
                    />
                  )}
                </div>
                <div className="pie-chart">
                  <h6>Campaign Distribution</h6>
                  {isDashboardLoading ? (
                    <Loader />
                  ) : (
                    <Charts
                      type="Admin-compaign-pie"
                      data={userChartData.userCampaignDistribution}
                    />
                  )}
                </div>
                <div className="pie-chart">
                  <h6>Template Distribution</h6>
                  {isDashboardLoading ? (
                    <Loader />
                  ) : (
                    <Charts
                      type="Admin-Template-pie"
                      data={userChartData.userTemplateDistribution}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <DashCards data={USER_DASHBOARD_DATA} onCardClick={handleCardClick} />
          <div className="dashboard-data">
            <div className="sub-dash">
              <div className="charts-container">
                <div className="pie-chart">
                  <h6>Wallet Distribution</h6>
                  <Charts type="wallet-pie" data={walletChartData} />
                </div>
                <div className="pie-chart">
                  <h6>Channel Distribution</h6>
                  {isDashboardLoading ? (
                    <Loader />
                  ) : (
                    <Charts
                      type="user-channel-pie"
                      data={userChartData.userChannelDistribution}
                    />
                  )}
                </div>
                <div className="pie-chart">
                  <h6>Campaign Distribution</h6>
                  {isDashboardLoading ? (
                    <Loader />
                  ) : (
                    <Charts
                      type="user-compaign-pie"
                      data={userChartData.userCampaignDistribution}
                    />
                  )}
                </div>
                <div className="pie-chart">
                  <h6>Template Distribution</h6>
                  {isDashboardLoading ? (
                    <Loader />
                  ) : (
                    <Charts
                      type="user-Template-pie"
                      data={userChartData.userTemplateDistribution}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default Dashboard
